import type { ThunkAction } from '@reduxjs/toolkit';
import type { RootState } from 'store/index';
import { GeneralService } from 'store/services/general.service';
import { generalSliceActions } from './config';
import type { ContactRequestBody, Translation } from './general.slice';
export interface GetTranslationsQuery {
  query: string;
  page: string;
  pageSize: string;
}

export const getAllTranslations =
  (): ThunkAction<void, RootState, unknown, any> => async (dispatch) => {
    try {
      dispatch(generalSliceActions.setTranslationsPendingStatus(true));
      const response = await GeneralService.getAllTranslations({}, true);
      dispatch(generalSliceActions.setAllTranslations(response.rows));
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(generalSliceActions.setTranslationsPendingStatus(false));
    }
  };
export const getPageContents =
  (
    queryParams: Partial<GetTranslationsQuery>,
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch) => {
    try {
      dispatch(generalSliceActions.setTranslationsPendingStatus(true));
      const response = await GeneralService.getAllTranslations(queryParams);
      dispatch(generalSliceActions.setPageContents(response.rows));
      dispatch(generalSliceActions.setTranslationsCount(response.count));
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(generalSliceActions.setTranslationsPendingStatus(false));
    }
  };

export const createNewTranslation =
  (
    payload: Omit<Translation, 'id'>,
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch) => {
    try {
      dispatch(generalSliceActions.setTranslationsPendingStatus(true));
      const response = await GeneralService.createNewTranslation(payload);
      dispatch(generalSliceActions.setNewTranslation(response));
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(generalSliceActions.setTranslationsPendingStatus(false));
    }
  };

export const updateTranslation =
  (payload: Translation): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch) => {
    try {
      dispatch(generalSliceActions.setTranslationsPendingStatus(true));
      const response = await GeneralService.updateTranslation(payload);
      dispatch(generalSliceActions.editTranslation(response));
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(generalSliceActions.setTranslationsPendingStatus(false));
    }
  };

export const getSupportEmails =
  (): ThunkAction<void, RootState, unknown, any> => async (dispatch) => {
    try {
      dispatch(generalSliceActions.setSupportEmailsPendingStatus(true));
      const response = await GeneralService.getSupportEmails();
      dispatch(
        generalSliceActions.setSupportEmails(
          response.map((item) => item.email),
        ),
      );
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(generalSliceActions.setSupportEmailsPendingStatus(false));
    }
  };

export const sendMailToSupport =
  (payload: ContactRequestBody): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch) => {
    try {
      await GeneralService.sendMailToSupport(payload);
      dispatch(
        generalSliceActions.setAppMessage({
          type: 'success',
          message: 'Your message successfuly sended',
        }),
      );
    } catch (err: any) {
      throw new Error(err);
    }
  };

export const exportTranslations =
  (): ThunkAction<void, RootState, unknown, any> => async (dispatch) => {
    try {
      dispatch(generalSliceActions.setExportPendingStatus(true));
      await GeneralService.downloadTranslations();
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(generalSliceActions.setExportPendingStatus(false));
    }
  };
